module.exports = __webpack_public_path__ + "img/m1.71283870.png";